import {
  toBool,
  fromBool,
  checkPercentage,
  toBlockOrNumber,
} from "views/Config/PolicyEdit/utils";

export const responsePolicyMap = {
  "Name:": {
    name: "name",
    valueF: function (value) {
      return value;
    },
  },
  "Optimization:": {
    name: "opt",
    valueF: function (attrsString) {
      const attrs = attrsString.split(/\s+/);
      if (attrs.length > 1) {
        var ini = attrs[1].indexOf("-"),
          end = attrs[1].lastIndexOf("%");
        return Number(attrs[1].substring(ini + 1, end));
      } else {
        var acc = toBool(attrs[0]);
        return acc ? 100.0 : acc;
      }
    },
  },
  "Blocking:": {
    name: "block",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Shaping-per-subscriber downlink:": {
    name: "shapd",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Shaping-per-subscriber downlink: Rate:": {
    name: "shdrate",
    valueF: function (attrs) {
      if (checkPercentage(attrs)) {
        return attrs;
      }
      return (Number(attrs) / 1000).toFixed(3);
    },
  },
  "Shaping priority:": {
    name: "priority",
    valueF: function (attrs) {
      return Number(attrs);
    },
  },
  "Shaping-per-subscriber downlink: Burst rate:": {
    name: "shdbrate",
    valueF: function (attrs) {
      if (checkPercentage(attrs)) {
        return attrs;
      }
      return (Number(attrs) / 1000).toFixed(3);
    },
  },
  "Shaping-per-subscriber downlink: Burst duration:": {
    name: "shdbdur",
    valueF: function (attrs) {
      return Number(attrs);
    },
  },
  "Shaping-per-subscriber downlink: Burst threshold:": {
    name: "shdbthr",
    valueF: function (attrs) {
      if (checkPercentage(attrs)) {
        return attrs;
      }
      return (Number(attrs) / 1000).toFixed(3);
    },
  },
  "Shaping-per-subscriber downlink: Burst threshold window:": {
    name: "shdbthrw",
    valueF: function (attrs) {
      return Number(attrs).toFixed(0);
    },
  },
  "Shaping-per-flow downlink:": {
    name: "shapdflow",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Shaping-per-flow downlink: Rate:": {
    name: "shapdflowrate",
    valueF: function (attrs) {
      if (checkPercentage(attrs)) {
        return attrs;
      }
      return (Number(attrs) / 1000).toFixed(3);
    },
  },
  "Shaping-per-subscriber uplink:": {
    name: "shapu",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Shaping-per-subscriber uplink: Rate:": {
    name: "shurate",
    valueF: function (attrs) {
      if (checkPercentage(attrs)) {
        return attrs;
      }
      return (Number(attrs) / 1000).toFixed(3);
    },
  },
  "Shaping-per-subscriber uplink: Burst rate:": {
    name: "shubrate",
    valueF: function (attrs) {
      if (checkPercentage(attrs)) {
        return attrs;
      }
      return (Number(attrs) / 1000).toFixed(3);
    },
  },
  "Shaping-per-subscriber uplink: Burst duration:": {
    name: "shubdur",
    valueF: function (attrs) {
      return Number(attrs);
    },
  },
  "Shaping-per-subscriber uplink: Burst threshold:": {
    name: "shubthr",
    valueF: function (attrs) {
      if (checkPercentage(attrs)) {
        return attrs;
      }
      return (Number(attrs) / 1000).toFixed(3);
    },
  },
  "Shaping-per-subscriber uplink: Burst threshold window:": {
    name: "shubthrw",
    valueF: function (attrs) {
      return Number(attrs).toFixed(0);
    },
  },
  "Shaping-per-flow uplink:": {
    name: "shapuflow",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Shaping-per-flow uplink: Rate:": {
    name: "shapuflowrate",
    valueF: function (attrs) {
      if (checkPercentage(attrs)) {
        return attrs;
      }
      return (Number(attrs) / 1000).toFixed(3);
    },
  },
  "UDR:": {
    name: "optFullUDR",
    valueF: (value) =>toBool(...value.split(/\s+/)),
  },
  "Trace:": {
    name: "optLowLevelTracking",
    valueF: (value) =>toBool(...value.split(/\s+/)),
  },
  "Allow rate-per-subscriber:": {
    name: "skiprate",
    valueF: function (attrs) {
      // skiprate = ! Allow rate-per-subscriber:
      return !toBool(attrs);
    },
  },
  "Allow rate-per-subscriber-group:": {
    name: "skipsubsgrouprate",
    valueF: function (attrs) {
      // skipsubsgrouprate = ! Allow rate-per-subscriber:
      return !toBool(attrs);
    },
  },
  "Drop Internet TCP SYN:": {
    name: "droptcp",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Drop Internet UDP:": {
    name: "dropudp",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Drop Internet IP-Other:": {
    name: "dropother",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Quota:": {
    name: "quota",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Block subscriber:": {
    name: "blockSubscriber",
     valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "Block subscriber: Block rate downlink:": {
    name: "quotad",
    valueF: function (attrs) {
      return toBlockOrNumber(attrs);
    },
  },
  "Block subscriber: Block rate uplink:": {
    name: "quotau",
    valueF: function (attrs) {
      return toBlockOrNumber(attrs);
    },
  },
  "DSCP downlink:": {
    name: "shapddscp",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "DSCP downlink: Code Point:": {
    name: "shapddscprate",
    valueF: function (attrs) {
      return Number(attrs);
    },
  },
  "DSCP uplink:": {
    name: "shapudscp",
    valueF: function (attrs) {
      return toBool(attrs);
    },
  },
  "DSCP uplink: Code Point:": {
    name: "shapudscprate",
    valueF: function (attrs) {
      return Number(attrs);
    },
  },
};

export const DEFAULT_POLICY = {
  name: "",
  block: false,
  optEnabled: true,
  opt: 1, // Tracking
  optFullUDR: false,
  optLowLevelTracking: false,
  priority: 0,
  shapd: false,
  shdrate: 100,
  shdrateUnit: "%",
  shdbrate: 0,
  shdbrateUnit: "mbps",
  shdbdur: 0,
  shdbthr: 0,
  shdbthrUnit: "mbps",
  shdbthrw: 300,
  shapdflow: false,
  shapdflowrate: 100000.000,
  shapdflowrateUnit: "mbps",
  shapddscp: false,
  shapddscprate: 0,
  shapu: false,
  shurate: 100,
  shurateUnit: "%",
  shubrate: 0,
  shubrateUnit: "mbps",
  shubdur: 0,
  shubthr: 0,
  shubthrUnit: "mbps",
  shubthrw: 300,
  shapuflow: false,
  shapuflowrate: 100000.000,
  shapuflowrateUnit: "mbps",
  shapudscp: false,
  shapudscprate: 0,
  skiprate: false,
  skipsubsgrouprate: false,
  quota: true,
  quotaLimit: false,
  quotad: 1000.000,
  quotau: 1000.000,
  droptcp: false,
  dropudp: false,
  dropother: false,
  blockSubscriber: true,
};

